import { urlWithParams } from '@marketplace-web/shared/utils'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const FORGOT_PASSWORD_URL = '/member/general/reset_password'
export const ROOT_URL = '/'
export const TERMS_URL = '/terms_and_conditions'
export const IMPRESSUM_URL = '/impressum'
export const BUSINESS_TERMS_URL = '/pro-terms-of-use'
export const LOGIN_SELECT_TYPE = '/member/login/select_type'
export const LOGIN_EMAIL = '/member/login/email'
export const LOGIN_2FA = '/member/login/2fa'
export const LOGIN_RESET_PASSWORD = '/member/login/reset_password'
export const REGISTER_SELECT_TYPE = '/member/register/select_type'
export const REGISTER_EMAIL = '/member/register/email'
export const REGISTER_FACEBOOK = '/member/register/facebook'
export const REGISTER_GOOGLE = '/member/register/google'
export const REGISTER_APPLE = '/member/register/apple'
export const REGISTER_PASSWORD_VERIFICATION = '/member/register/password_verification'
export const SIGNUP_URL = '/member/signup/select_type'
export const SIGNUP_HELP_ENTRIES_URL = '/help/103'
export const PRIVACY_POLICY_URL = '/privacy-policy'
export const BUSINESS_TERMS_AND_CONDITIONS_URL = '/pro-terms-and-conditions'
export const BUSINESS_TERMS_OF_SALE_URL = '/pro-terms-of-sale'
export const BUSINESS_ACCOUNT_REGISTER_URL = '/pro/register'
